module.exports = __webpack_public_path__ + "img/eye_open.07838ed7.svg";